import { Component, inject } from '@angular/core';
import { LoaderService } from './services/loader.service';
import { IconService } from './services/icon.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss'
})
export class AppComponent {
  
  sidebarCollapsed = false;

  private _loader = inject(LoaderService);
  
  private _icons = inject(IconService);

  isLoading = this._loader.loading$;
  
  isProcessing = this._loader.processing$;

  constructor() {
    this._icons.init();
  }

  onSidebarToggled(collapsed: boolean) {
    this.sidebarCollapsed = collapsed;
  }
}
